// extracted by mini-css-extract-plugin
export default {"containerList":"Box_containerList__z36a9","list1":"Box_list1__ZyBHy","list2":"Box_list2__2Yxs+","list3":"Box_list3__rwmsG","logo":"Box_logo__49iEA"};